import React from "react";
import { List } from "../modules/Settings/Laboratories";

export function LaboratoriesListPage() {
  return <List />;
}
